module.exports = __webpack_public_path__ + "img/cd_user.abc9180c.png";